import React, { useState, useEffect } from "react";
import axios from "axios";
import ReactPaginate from "react-paginate";
import clienteAxios from "../../helpers/axios.helper";
import Swal from "sweetalert2";

function TablaUsuarios() {
  const [usuariosData, setUsuariosData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 15;

  useEffect(() => {
    const fetchUsuarios = async () => {
      try {
        setLoading(true);
        const response = await clienteAxios.get("/usuarios");
        setUsuariosData(response.data.usuarios);
      } catch (err) {
        const errorMessage = "Error al cargar los usuarios.";
        setError(errorMessage);

        // Mostrar el mensaje de error con SweetAlert
        Swal.fire({
          icon: "error",
          title: "Error",
          text: errorMessage,
        });
      } finally {
        setLoading(false);
      }
    };

    fetchUsuarios();
  }, []);

  const offset = currentPage * itemsPerPage;
  const currentItems = usuariosData.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(usuariosData.length / itemsPerPage);

  const toggleHabilitacion = async (id) => {
    try {
      const response = await clienteAxios.put(`/usuarios/habilitacion/${id}`);
      const nuevoEstado = response.data.nuevoEstado;

      setUsuariosData((prevUsuarios) =>
        prevUsuarios.map((usuario) =>
          usuario.id === id ? { ...usuario, estaHabilitado: nuevoEstado } : usuario
        )
      );
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Error al cambiar el estado de habilitación del usuario.",
      });
    }
  };

  const eliminarUsuario = async (id) => {
    Swal.fire({
      title: "¿Estás seguro?",
      text: "Esta acción eliminará al usuario permanentemente.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await clienteAxios.delete(`/usuarios/eliminar/${id}`);
          setUsuariosData((prevUsuarios) =>
            prevUsuarios.filter((usuario) => usuario.id !== id)
          );
          Swal.fire({
            icon: "success",
            title: "Usuario eliminado",
            text: "El usuario se eliminó correctamente.",
          });
        } catch (err) {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Error al eliminar el usuario.",
          });
        }
      }
    });
  };

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  if (loading) {
    return <div className="text-center">Cargando usuarios...</div>;
  }

  if (error) {
    return (
      <div className="text-center text-red-500">
        {error}
      </div>
    );
  }

  return (
    <div className="bg-white p-4 rounded-lg border-2 border-GrisOscuro">
      <table className="min-w-full bg-white border">
        <thead>
          <tr>
            <th className="text-start py-2 px-4 border-b">Nombre</th>
            <th className="text-start py-2 px-4 border-b">Correo</th>
            <th className="text-start py-2 px-4 border-b">Rol</th>
            <th className="text-start py-2 px-4 border-b">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((usuario) => (
            <tr key={usuario.id}>
              <td className="py-2 px-4 border-b">{usuario.nombre}</td>
              <td className="py-2 px-4 border-b">{usuario.email}</td>
              <td className="py-2 px-4 border-b">{usuario.rol}</td>
              <td className="py-2 px-4 border-b">
                <div className="flex space-x-2">
                  <button
                    onClick={() => toggleHabilitacion(usuario.id)}
                    className={`px-3 py-1 ${
                      usuario.estaHabilitado ? "bg-yellow-500" : "bg-green-500"
                    } text-white rounded border hover:bg-white hover:text-black hover:border-green-500`}
                  >
                    {usuario.estaHabilitado ? "Deshabilitar" : "Habilitar"}
                  </button>
                  <button
                    onClick={() => eliminarUsuario(usuario.id)}
                    className="px-3 py-1 bg-red-500 text-white rounded border hover:bg-white hover:text-black hover:border-red-500"
                  >
                    Eliminar
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
      <div className="flex w-full flex-row h-20 justify-center items-end">
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
          containerClassName="flex justify-center items-center"
          pageClassName="p-1 px-3 text-Nergro bg-GrisClaro"
          activeClassName="bg-GrisOscuro text-Blanco"
          previousClassName="px-2 py-1 text-Rojo font-bold text-xl"
          nextClassName="px-2 py-1 text-Rojo font-bold text-xl"
          breakClassName="px-2 py-1 text-Rojo"
        />
      </div>
    </div>
  );
}

export default TablaUsuarios;
